import axios from 'axios';
import Auth from '../auth';
import { getObleaResponseFailure, createObleaValidationRejection } from '../utilities';
import { normalizeBuscarNovedadesParams } from '../utilities/Novedades/normalizeBuscarNovedadesParams';
import {
    extractNovedadesResultadosRawList,
    normalizeNovedadItem
} from '../utilities/Novedades/extractNovedadesResultadosRawList';

export const url = "";

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const url = error?.config?.url || '';

        const esIntegracionOAuth =
            url.includes('/oauth/zipnova') ||
            url.includes('/api/oauth/');

        const esProxyBff =
            url.includes('/Proxy') ||
            url.includes('/EncabezadoProxy') ||
            url.includes('/EncabezadosProxy');

        const isLocalhostRuntime =
            typeof window !== 'undefined' &&
            window.location &&
            window.location.hostname === 'localhost';

        if (status === 401 && !esIntegracionOAuth && !esProxyBff && !isLocalhostRuntime) {
            Auth.logout();
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export const loginApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/login`,
            data: request
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const impersonateUserApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/impersonate`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getGrupoPlanesById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes/Planes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteGrupoPlanesById = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Administracion/GrupoPlanes?id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoPlanesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getPlanesPorParametrosApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Planes`,
            params: params ?? null
        }
        ).then(response => {
          resolve(response ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchDashboardTotalizadoresApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Dashboard/Totalizadores`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const obtenerUsuariosDeSeller = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/BuscarProxy`,
            params: params ?? null
        }
        ).then(response => {
          resolve(response?.data ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postSearchUsuarioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerUsuarioProxy`,
            params: data
        })
            .then(response => {
                resolve(response?.data ?? {});
            })
            .catch(err => reject(err));
    });
};

export const postSearchTokenUsuario = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${url}/api/Usuarios/ObtenerTokenUsuarioProxy`,
      data: {
        idUsuario: data?.idUsuario ?? data.IdUsuario
      },
      headers: { 'Content-Type': 'application/json' }
    }
    ).then(response => {
      resolve(response);
    }
    ).catch(err => {
      reject(err);
    })
  })
}

export const obtenerTiposUsuarioApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/GetTiposUsuario`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postChangeStateUsuario = (data) => { // ESTE MÉTODO NO SE ESTÁ LLAMANDO DESDE NINGÚN LADO
    console.log(data, "🎀")
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CambiarEstado`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const modificarUsuario = (data) => { // ESTE MÉTODO NO SE ESTÁ LLAMANDO DESDE NINGÚN LADO
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion/AsociarGrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }

        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarSeller = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion/AsociarSeller`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getTiposPublicacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/TiposPublicacion`,
            params: request
        }).then(response => {
          resolve(response ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const getAuditoriaAdministracionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/ObtenerAuditoriaAdministracion`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const deleteAdministracionTiposPublicacion = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Administracion/TiposPublicacion?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postFacturaOrdenes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const postCrearOrden = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/CrearOrden`,
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getFacturaOrdenesApi = (query) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/Ordenes/Comprobantes?${query}`,
    }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
  })
}

export const getComprobanteOrdenes = (idOrden) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Obleas?idOrden=${idOrden}`,
        }
        ).then(response => {
            const failure = getObleaResponseFailure(response.data);
            if (failure.failed) {
                reject(createObleaValidationRejection(failure));
                return;
            }
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchSellersApi = (params) => { // ESTE MÉTODO NO SE ESTÁ UTILIZANDO EN NINGÚN COMPONENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchDesplegableProveedoresApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/DesplegableProveedores`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchProductosPorProveedorApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/StockProveedores/ProductosPorProveedor`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response?.data ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchVentasPorProveedorApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/StockProveedores/VentasPorProveedor`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response?.data ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchStockSucursalesProveedorApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/StockProveedores/StockSucursales`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response?.data ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchPublicacionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                ...params,
                DireccionOrdenamiento: 1,
                EntidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            resolve(response?.data);
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchPublicacionesEncabezadoApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/EncabezadosProxy`,
            params: params
        }).then(response => {
            resolve(response?.data);
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchTipoPublicacionApi = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Tipos`,
            params: { idSeller: idSeller }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchPublicacionApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                idPublicacion: id,
                direccionOrdenamiento: 1,
                entidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchPublicacionAuditoriaPrecioStockApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AuditoriaPrecioStock`,
            params: params ?? null
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchSellerAuditoriaApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerAuditoriaSeller`,
            params: params ?? null
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchPublicacionPorSkuMarketApi = (skuMarket) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                skuMarket: skuMarket,
                direccionOrdenamiento: 1,
                entidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchVariacionesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Variaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcasApi = (descripcion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/Marcas`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                descripcion: descripcion
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcaApi = (idMarca) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            // Marca por id (no detalle de artículo)
            url: `${url}/api/Articulos/Marcas/${encodeURIComponent(idMarca)}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then(response => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        })
    })
}


export const fetchCategoriasApi = (descripcion) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/Articulos/SubFamiliasByParams`,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
      params: {
        descripcion: descripcion
      }
    }).then(response => {
      const data = response?.data ?? {};
      const categoriasArray = data?.elementos ?? data?.Elementos ?? data?.categorias ?? data?.Categorias ?? data?.content ?? data?.Content ?? (Array.isArray(data) ? data : []);
      resolve({
        ...data,
        elementos: categoriasArray
      });
    }).catch(error => {
      reject(error)
    })
  })
}

export const fetchCategoriaApi = (descripcion) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/Articulos/SubFamilias`,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
      params: {
        descripcion: descripcion,
      },
    }).then(response => {
      const data = response?.data ?? {};
      const categoriasArray = data?.elementos ?? data?.Elementos ?? data?.categorias ?? data?.Categorias ?? data?.content ?? data?.Content ?? Array.isArray(data) ? data : [];
      resolve({
        ...data,
        elementos: categoriasArray
      });
    }).catch((error) => {
      reject(error);
    })
  })
}

export const createPublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateImagenesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ModificarImagenesBulk`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePosicionesImagenesApi = (request) => { // SE USA EN DrawAndDropImages pero el componente no se está usando.
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarPosicionImagenes`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const deletePublicacionApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Publicaciones/${encodeURIComponent(id)}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosRevisionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/MotivosRevision`
        }).then((response) => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosSolicitudAnulacionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/MotivosSolicitudAnulacion`
        }).then((response) => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const updatePublicacionEstadoVariacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/Variaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Aprobar`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postDesaprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Desaprobar`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteSellerApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Seller?IdSeller=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const getOrden = (idOrden, idUsuario) => {

    let request = {
        IdOrden: idOrden,
        IdUsuario: idUsuario
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Proxy`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
};

export const fetchOrdenesParams = (request) => { // SE USA EN EL ACTIONS PERO EL MÉTODO DEL ACTIONS NO SE ESTÁ USANDO EN UN COMPONENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Proxy`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEncabezadoParams = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/EncabezadoProxy`,
            params: params
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEnVerdeParams = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/OrdenesProveedores`,
            params: request
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObtenerEstadoVenta`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAnularOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnularEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AprobarEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postSolicitudAnulacionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/SolicitudAnulacion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postAnulacionReversionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnulacionReversion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const listSellers = () => { // ESTE MÉTODO NO SE ESTÁ USANDO EN NINGÚN COMPONENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const listSellersParameters = (Descripcion, CantidadPagina, NumeroPagina) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?Descripcion=${Descripcion || ''}&PageSize=${CantidadPagina}&Page=${NumeroPagina}`
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getSeller = (IdSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?IdSeller=${IdSeller}&NumeroPagina=1&CantidadPagina=1`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getIntegradores = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integrators`,
        }).then(response => {
            resolve(response.data.integradores);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTipoFacturacion = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Facturacion`,
        }).then(response => {
            resolve(response.data.tiposFacturacion);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getEstadosSeller = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller`,
            data: data
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postUser = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios`,
            data
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}


export const editUser = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/${data.idUsuario}`,
            data
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const putSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller`,
            data: data
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const createImageUrl = (img) => {

    if (img.type.includes("image")) {
        let form = new FormData();

        form.append('', img, img.name);

        return new Promise((resolve, reject) => {
            axios({
                "url": "/Imagen",
                "method": "POST",
                "timeout": 0,
                "data": form
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    } else {
        return Promise.reject("Archivo incorrecto");
    }
}

export const createImageSellerUrl = (img) => {

    if (img.type.includes("image")) {
        let form = new FormData();

        form.append('', img, img.name);

        return new Promise((resolve, reject) => {
            axios({
                "url": "/Imagen/Seller",
                "method": "POST",
                "timeout": 0,
                "data": form
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    } else {
        return Promise.reject("Archivo incorrecto");
    }
}

export const leerExcelPublicaciones = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcel",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const leerExcelPublicacionesPorCodigo = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcelPorCodigo",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const postCreacionMasivaPublicacionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CreacionMasiva`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicaciones = (data) => {

    let listaAtributos = {
        "listaAtributos": data
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasiva`,
            data: listaAtributos
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicacionesModerador = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPorCodigo`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * Actualización masiva bulk parcial → PUT api/Publicaciones/ActualizacionMasivaBulkParcial
 * No valida ni exige campos obligatorios del alta; el body puede incluir 1 o varios campos por publicación.
 */
export const putActualizacionMasivaBulkParcialApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaBulkParcial`,
            data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putExcelLiquidacionesFeeLogisticoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionMasivaFeeLogistico`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getFeeLogisticoSellersApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/FeeLogistico`
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getDatosFeeLogisticoSellersApi = (VigenciaFeeLogistico) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/DatosFeeLogisticoSellers`,
            params: { VigenciaFeeLogistico }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}


export const fetchRebatesDeLiquidacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/Rebates`,
            params: request
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLocalidades = (params) => {
    let params_1 = { ...params, NumeroPagina: 1, CantidadPagina: 500 };
    return new Promise((resolve) => {
        axios({
            method: 'get',
            url: `${url}/api/Localidades`,
            params: (params_1) ? params_1 : null
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            resolve(error);
        })
    })
}

export const getSituacionIva = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/SituacionIva`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTiposAdquirientes = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Adquirientes`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTiposSexo = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Sexo`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionesListaSellers = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/TraerSellerLiquidaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTiposConceptosApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/NovedadesLiquidacion/TraerConceptoNovedad`
        }).then(response => {
          resolve(response?.data ?? {});
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionporid = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ConsultarDetalleLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getOrdenesParaNuevaLiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesPorFecha`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getNovedadesParaNuevaLiquidacion = (request) => {
    const params = normalizeBuscarNovedadesParams(request);

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/NovedadesLiquidacion/BuscarNovedades`,
            params
        }).then(response => {
            const data = response?.data ?? {};
            const rawList = extractNovedadesResultadosRawList(data);
            const novedades = rawList.map(normalizeNovedadItem);
            resolve({
                ...data,
                novedades
            });
        }).catch(error => {
            reject(error);
        })
    })
}

export const getLiquidacionPorIdOrdenes = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLogistica = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/Cotizaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionPorIdNovedades = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/NovedadesLiquidacion/BuscarNovedadesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postNovedad = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidacion/CrearNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearLiquidacionFinal`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinalLogistica = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/EnvioPack/Cotizaciones`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaNovedadConcepto = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidacion/CrearConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesLiquidaciones = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
            url: `${url}/api/NovedadesLiquidacion/TraerSubtipoNovedades`
    }).then(response => {
      const data = response?.data ?? {};
      const listadoNovedadesSubtipo = data?.listadoNovedadesSubtipo ?? data?.ListadoNovedadesSubtipo ?? data?.subTiposNovedades ?? data?.SubTiposNovedades ?? data?.elementos ?? data?.Elementos ?? data?.content ?? data?.Content ?? data?.data ?? [];
      resolve({
        ...data,
        listadoNovedadesSubtipo
      })
    }).catch(error => {
      reject(error)
    })
  })
}

export const getEstadosLiquidaciones = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
            url: `${url}/api/NovedadesLiquidacion/TraerEstadoNovedades`
    }).then(response => {
      const data = response?.data ?? {};
      const listadoEstadosNovedades = data?.listadoEstadosNovedades ?? data?.ListadoEstadosNovedades ?? data?.estados ?? data?.Estados ?? [];
      resolve({
        ...data,
        listadoEstadosNovedades
      });
    }).catch(error => {
      reject(error)
    })
  })
}

export const getEstadosLiquidacionesCorrecto = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerEstadosLiquidacionesCorrecto`
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error)
        })
    })
}

export const getResultadosLiquidaciones = (request) => {
    const params = normalizeBuscarNovedadesParams(request);

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/NovedadesLiquidacion/BuscarNovedades`,
            params
        }).then(response => {
            const data = response?.data ?? {};
            const rawList = extractNovedadesResultadosRawList(data);
            const novedades = rawList.map(normalizeNovedadItem);
            resolve({
                ...data,
                novedades
            });
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLiquidacionesBusqueda = (params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/Liquidaciones/LiquidacionesBusqueda`,
      params
    }).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err);
    })
  })
}

export const putEliminaNovedadFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/NovedadesLiquidacion/AnularNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaConceptoFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/NovedadesLiquidacion/AnularConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaLiquidacionFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EliminarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);

        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaConceptoFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/NovedadesLiquidacion/ActualizarConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaLiquidacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EditarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putConfirmarLiquidacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ConfirmarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const putEditaNovedadImporte = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/NovedadesLiquidacion/EditarNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postFacturarLiquidacionApi = ({ idLiquidacion, IdLiquidacion } = {}) => {
    const id = IdLiquidacion ?? idLiquidacion;
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidacion/FacturarLiquidacion`,
            params: { IdLiquidacion: id }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
};

export const postGenerarNotaDeCreditoApi = ({ idLiqui }) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidacion/GenerarNotaCredito`,
            params: { idLiqui }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
};

export const putConfirmaNovedad = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/NovedadesLiquidacion/ConfirmaNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const fetchExportarPublicacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Publicaciones`,
            params: {
                FechaPubDesde: request?.fechaPubDesde ?? request?.FechaPubDesde ?? null,
                FechaPubHasta: request?.fechaPubHasta ?? request?.FechaPubHasta ?? null,
                IdSeller: request?.idSeller ?? request?.IdSeller ?? null,
                Categoria: request?.categoria ?? request?.Categoria ?? null,
                Marca: request?.marca ?? request?.Marca ?? null,
                Estado: request?.estado ?? request?.Estado ?? null,
                SkuSeller: request?.skuSeller ?? request?.SkuSeller ?? null,
                SkuMarket: request?.skuMarket ?? request?.SkuMarket ?? null,
                IdTipoPubli: request?.idTipoPubli ?? request?.IdTipoPubli ?? null,
                SinStock: request?.sinStock ?? request?.SinStock ?? null,
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const fetchExportarOrdenesApi = (request) => {
    return new Promise((resolve, reject) => {
        // POST: el BFF reenvía el body como query a la API externa. GET con `data` no envía filtros.
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ExportarOrdenes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarOrdenesTelefonicasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarOrdenesTelefonicas`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Liquidaciones`,
            params: {
                idLiquidacion: request?.idLiquidacion ?? request?.IdLiquidacion ?? request?.id ?? request?.Id ?? null
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Sellers`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarMarcasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Marcas`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarCategoriasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/SubFamilias`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const requestTokenResetPassword = (Email) => { // SE USA EN ACTIONS Y TAMBIÉN DIRECTAMENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/Api/Usuarios/TokenResetPassword?Email=${Email}`
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

// Admin helper: requests reset-password token but DOES NOT mutate auth/session.
export const requestTokenResetPasswordAdmin = (Email) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/TokenResetPassword?Email=${Email}`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchTotalNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Notificaciones/Total`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchDetalleNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/Detalle`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchMarcarLeidasNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/MarcarLeidas`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Notificaciones/Ajustes`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Notificaciones/Ajustes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/Buscar`,
            params: { IdPublicacion: request }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchListRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/ListarRebates`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionExcelApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarLiquidacionExcel`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Rebates/Nuevo`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Rebates/Modificar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const deleteRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Rebates?id=${request}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postAprobarRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Rebates/Aprobar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchComprobanteVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const guardarDescargaObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchLogisticaPropiaApi = (idSeller) => {
  return axios.get(`${url}/api/LogisticaPropia`, {
    params: { idSeller: Number(idSeller) }
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw error;
    });
};


export const estructuraFeeLogistico = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/EstructuraFee`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateFeeLogistico = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearFee`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateLogisticaPropiaApi = (request) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${url}/api/LogisticaPropia`,
      data: request
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error)
    })
  });
}

export const updateFeeLogisticoSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionFeeLogisticoSellers`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateFeeLogisticosActivoProximo = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionFeeMegatone`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const descargarObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/DescargarObleaVentaVerde`,
            params: request
        }).then(response => {
            const failure = getObleaResponseFailure(response.data);
            if (failure.failed) {
                reject(createObleaValidationRejection(failure));
                return;
            }
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchGarantiasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Garantias`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateUrlTrackingApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ActualizarUrlTracking`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const putEstadoSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/CambiarEstadoSeller`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const updatePublicacionPrecioYStockBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPrecioYStockBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const updatePublicacionDimensionesBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarDimensionesBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const updatePublicacionEstadoBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/CambiarEstadoPublicacionBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}
export const getLiquidacionPdf = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/LiquidacionPdf`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

/** Factura de liquidacion por idLiquidacion — JSON { errores, archivo } (archivo = base64 PDF). */
export const getExportablesFacturaLiquidacionApi = (params) => {
    return axios({
        method: 'get',
        url: `${url}/api/Exportables/Liquidaciones/Factura`,
        params
    })
}

/** Subida de PDF de comprobantes (admin/category). Body JSON { archivo: base64 } → api/Liquidacion/ComprobantesPago/Procesar. */
export const postComprobantesLiquidacionPdfApi = (payload) => {
    return axios({
        method: 'post',
        url: `${url}/api/Liquidaciones/ComprobantesPdf`,
        data: payload,
        headers: { 'Content-Type': 'application/json' }
    })
}

/** Comprobante de pago por idSeller — JSON { errores, archivo } (archivo = base64 PDF). Ruta = Swagger (Comrobante con "r"). */
export const getExportablesComprobanteDePagoApi = (params) => {
    return axios({
        method: 'get',
        url: `${url}/api/Exportables/Liquidaciones/ComrobanteDePago`,
        params
    })
}

export const fetchExportarCertificadosPdfApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarCertificadosPdf`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarCertificadoImpuestosAnexoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarCertificadoImpuestosAnexos`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarRetencionesYPercepcionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarRetencionesYPercepciones`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postCalcularPercepcionRetencionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CalcularPercepcionRetencionesLiquidacion`,
            data: request,
            timeout: 0,
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTipoComprobantesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TiposComprobantes`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getLiquidacionesAuditoriaApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidacion/ListarTransacciones`,
            params,
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchAlicuotaIvaApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AlicuotasIva`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postCrearCdnSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CrearCdnSeller`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteCdnSellerApi = (id) => { // ESTE MÉTODO NO SE ESTÁ UTILIZANDO EN NINGÚN LADO
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Seller/EliminarCdnSeller`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                Id: id,
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const updateCdnSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/EditarCdnSeller`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getDetallesRetenciones = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/CargasTributarias`,
            params: {
                idLiquidacion: id
            }
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getProvinciaLocalidadByCodigoPostalApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerLocalidadProvincia`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const enlazarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/EnlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const confirmarMfaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/ConfirmarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const desenlazarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/DesenlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deshabilitarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/DesenlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postVerificarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/VerificarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postCargarDatosBancariosApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CargarDatosBancarios`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getDatosBancariosApi = (request) => {
    const idSeller = request?.IdSeller ?? request?.idSeller;
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerDatosBancariosSeller`,
            params: (idSeller !== undefined && idSeller !== null)
                ? { IdSeller: idSeller }
                : request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postMasivaImagenesExcelApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CargaMasivaImagenesExcel`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const getFormatoExcel = ({ tipoExcel }) => {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/api/Exportables/Publicaciones/ModelosExcel`, {
            params: { TipoModeloExcel: tipoExcel }
        })
            .then(resp => {
                resolve(resp);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const getTotalizadores = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/Totalizadores`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getEstadoResumen = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/ResumenEstados`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getTopProducto = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopProducto`,
            params: params ?? null
        })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const getTopCategorias = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopCategorias`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTopTipoPublicaciones = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopTipoPublicaciones`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getVentasMensuales = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/VentasMensuales`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postChatBot = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatBot`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postTicket = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/Ticket`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchAgentsApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/Categorys`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const postIniciarChat = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatIniciar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postFinalizarChat = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatFinalizar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}


export const postCrearChatInterno = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatCrear`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postChatMensaje = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatMensaje`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateEstadoTiposPublicaciones = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/EstadoTipoPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchGlobal = (searchValue, idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/BusquedaGlobal`,
            params: {
                entrada: searchValue,
                idSeller: idSeller
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const getChatInterno = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Categorys`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}
// export const getChatToken = (userId = null) => {

//         const params = userId ? `?userId=${userId}` : '';
//         axios({
//             method: 'get',
//             url: `${url}/api/Administracion/GetChatToken${params}`,
//             // No incluir headers de autorización porque es para obtener el token inicial
//         }).then(response => {
//             resolve(response.data);
//         }).catch(error => {
//             reject(error);
//         })
//     })
// }

export const fetchBancosApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerBancos`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postCargarDatosBancariosManualApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CargarDatosBancariosManual`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getlistGestionDatosBancariosSellersTesoreriaApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/GestionDatosBancariosSellersTesoreria`,
            params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const updateEstadoBancarioCbuSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/CambiarEstadoDatoBancario`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// export const getChatToken = (userId = null) => {

//     const params = userId ? `?userId=${userId}` : '';
//     axios({
//       method: 'get',
//       url: `${url}/api/Administracion/GetChatToken${params}`,
//       withCredentials: true // <= para que se setee/envíe la cookie
//     }).then(response => resolve(response.data))
//       .catch(reject);
//   });
// };

export const getChatInternoGrupo = (id) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/ChatInterno/Grupo/${id}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export const updateEstadoGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/EstadoGrupoPlanes`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const putActivarUsuario = (id) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/${id}/Activar`,
            data: {},
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            console.error("DEBUG: putActivarUsuario error", err.response);
            reject(err);
        })
    })
}

export const putPausarUsuario = (id) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/${id}/Pausar`,
            data: {},
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            console.error("DEBUG: putPausarUsuario error", err.response);
            reject(err);

        })
    })
}


export const getTiposUsuarios = (id = null) => { // SE USA EN EL ACTIONS Y TAMBIÉN DIRECTAMENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: id
                ? `${url}/api/Usuarios/ObtenerTipoUsuario?id=${id}`
                : `${url}/api/Usuarios/ObtenerTipoUsuario`,
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const postTiposUsuarios = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CrearTipoUsuario`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteTiposUsuarios = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Usuarios/EliminarTipoUsuario?Id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const updateTiposUsuarios = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/ModificarTipoUsuario`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)

        })
    })
}

export const postCargaMasivaComprobantesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/CargarMasivaComprobantes`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const putModificarMasivaComprobantes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Ordenes/ModificarMasivaComprobantes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putReemplazarComprobanteOrdenApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Ordenes/Comprobantes`,
            data: data
        }).then((response) => {
            resolve(response);
        }).catch((err) => {
            reject(err);
        })
    })
}

export const getAccionesPredefinidasTipoUsuarioApi = (idTipoUsuario) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerAccionesPredefinidasTipoUsuario`,
            params: { idTipoUsuario: idTipoUsuario }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAccionPredefinidaTipoUsuarioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CrearAccionPredefinidaTipoUsuario`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTopSellers = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopSellers`,
            params: params ?? null,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getTipoPublicaciones = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopTipoPublicaciones`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const deleteAccionPredefinidaTipoUsuarioApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Usuarios/EliminarAccionPredefinidaTipoUsuario`,
            params: { id: id }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerAcciones`,
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const autorizarZipnova = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Integraciones/Proveedor/Autorizar`,
            params: {
                IdUsuario: idSeller,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const estadoZipnova = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integraciones/Proveedor/Estado`,
            params: {
                IdUsuario: idSeller,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const desconectarZipnova = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Integraciones/Proveedor/Desconectar`,
            params: {
                IdUsuario: idSeller,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
};

export const getSellerDesplegableApi = (normalizedParams, token) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/DesplegableSeller`,
            params: normalizedParams,
            headers: token ? { Authorization: token } : undefined
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}


export const fetchAtributosCategoriaApi = (idSubFamilia) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AtributosCategoria`,
            params: {
                idSubFamilia: idSubFamilia
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAtributosPorCategoriaAgrupamientoApi = (idSubFamilia, idAgrupacion, descripcion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AtributosCategoria`,
            params: {
                idSubFamilia: idSubFamilia,
                idAgrupacion: idAgrupacion,
                descripcion: descripcion
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchValoresAtributoApi = (idAtributo, descripcion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/ValoresAtributo`,
            params: {
                idAtributo: idAtributo,
                descripcion: descripcion
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchEstructuraAtributosValoresApi = (codProducto, idCategoria) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/EstructuraAtributosValores`,
            params: {
                codProducto: codProducto,
                idCategoria: idCategoria
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAgrupamientosApi = (idCategoria) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Agrupamientos`,
            params: {
                idCategoria: idCategoria
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const CargarAtributosApi = (valores) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CargarAtributos`,
            data: valores
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const CargarBlisterApi = (id, datos) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/${id}/Blister`,
            data: datos
        })
        .then(response =>
            resolve(response.data))
        .catch(error =>
            reject(error));
    });
}

export const ObtenerBlisterApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/${id}/Blister`
        })
        .then(response =>
            resolve(response.data))
        .catch(error =>
            reject(error));
    });
}

export const EliminarBlisterApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Publicaciones/${id}/Blister`
        })
        .then(response =>
            resolve(response.data))
        .catch(error =>
            reject(error));
    });
}
